<div mat-dialog-content >
  <div>
    <div class="modal-header text-center">
      <h2 class="azul text-center" [ngClass]="tipografyTitle">{{ title }}</h2>
      <div type="button" class="close" mat-dialog-close aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </div>
    </div>
    <div #htmlDiv id="html" class="modal-body" [ngClass]="tipografy" [innerHTML]="html">
    </div>
  </div>
</div>